import { csv2json } from "json-2-csv";
export function getCSVToJSON(_ref) {
  var input = _ref.input,
    _ref$selectedSpaces = _ref.selectedSpaces,
    selectedSpaces = _ref$selectedSpaces === void 0 ? 2 : _ref$selectedSpaces;
  var res = csv2json(input);
  return JSON.stringify(res, null, selectedSpaces);
}